import { Services } from '@omnia/ui/src/lib'
import { cmsDataService } from './cms.data.service'
import { cmsService } from './cms.service'
import { navigationService } from './navigation.service'
import { urlService } from './url.service'

export const initServices = () => {
    Services.CmsDataService = cmsDataService
    Services.CmsService = cmsService as unknown as typeof Services.CmsService
    Services.NavigationService = navigationService as unknown as typeof Services.NavigationService
    Services.UrlService = urlService as unknown as typeof Services.UrlService
}
